import { createContext, Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react'

interface Props {
    children: ReactNode
}

export const RecoverPasswordContext = createContext({
    email: '',
    setEmail: () => {},
    code: '',
    setCode: () => {},
} as {
    email: string
    setEmail: Dispatch<SetStateAction<string>>
    code: string
    setCode: Dispatch<SetStateAction<string>>
})

const RecoverPasswordProvider = ({ children }: Props) => {
    const [email, setEmail] = useState<string>('')
    const [code, setCode] = useState<string>('')

    const providerValues = useMemo(
        () => ({
            email,
            setEmail,
            code,
            setCode,
        }),
        [email, setEmail, code, setCode],
    )

    return (
        <RecoverPasswordContext.Provider value={providerValues}>
            {children}
        </RecoverPasswordContext.Provider>
    )
}

export default RecoverPasswordProvider
